import { forwardRef } from 'react';
import { Switch as SwitchMui, FormControlLabel } from '@mui/material';

const Switch = forwardRef(({ checked, onChange }: { checked: boolean; onChange: (e: boolean) => void }, ref) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.checked);
  };

  return (
    <FormControlLabel
      control={<SwitchMui checked={checked} onChange={handleChange} color="primary" inputRef={ref} />}
      label={checked ? 'Yes' : 'No'}
    />
  );
});

export default Switch;
